// IMPORTANT: ensure this is in sync with the above type
export const textProperties = [
    'text',
    'bold',
    'italic',
    'strikethrough',
];
